import { connect } from "react-redux";
import usePlaylists from '../hooks/usePlaylists';

function ConnectedAPILinkWrapper({ api, isConnected, user }) {
  usePlaylists(api, isConnected, user); // Init Store Playlists Management
  return null;
}

const APILinkWrapper = connect(
  state => ({
    api: state.api,
    isConnected: state.isConnected,
    user: state.user
  })
)(ConnectedAPILinkWrapper);

export default APILinkWrapper;
